import React, { useEffect, useState } from 'react';
import Header from '../Header/Header';
import Project from '../Project/Project';

const Projects = () => {
    const [projects, setProjects] = useState([]);
    useEffect(() => {
        fetch('./PROJECT_DATA.json')
            .then(res => res.json())
            .then(data => setProjects(data))
    }, [])
    return (
        <div>
            <Header props="yes" />
            <h1 className="text-gray-600 text-3xl text-center pt-16 font-bold tracking-wider my-16">My Projects</h1>
            <section className="grid grid-cols-1 md:grid-cols-2 mx-6 md:mx-36 mb-20 gap-16">
                {
                    projects.map(p => <Project
                        key={p.title}
                        project={p}
                    ></Project>)
                }
            </section>
        </div>
    );
};


export default Projects;